<template>
    <div>
        <p v-html="notification.message" class="darkest"></p>
        <button class="btn tertiary narrow mt-2" @click="viewBooking">View booking</button>
    </div>
</template>

<script>
export default {
    created: function() {
        console.log('bodyNewBooking', this.notification);
    },
    props:{
        notification: {
            type: Object,
        }
    },
    methods: {
        viewBooking: function () {
            window.open('/reservations/view/'+this.notification.bookingId, '_blank');
        }
    }
}
</script>

<style lang="scss" scoped>
    p{
        word-break: break-word;
    }
</style>



// WEBPACK FOOTER //
// bodyNewBooking.vue?30d867f0